// @flow
import * as React from 'react';
import { noop } from 'lodash';

import { ICONS } from 'Components/utils/icon/icons';

import FormSelect from 'Components/frameworks/form-select/FormSelect.jsx';
import { BookingFormBlockField as BlockField } from 'Components/widgets/booking-form/block-field/BlockField.jsx';
import { getDurationOptions } from 'Components/widgets/booking-form/selectOptionsBuilders';

type Props = {
  durationOptionsFormat: string,
  durations: Array<number>,
  duration: number,
  title: string,
  setDuration: number => void,
};

const defaultProps: $Shape<Props> = {
  durations: [],
  duration: 7,
  setDuration: noop,
};

class Duration extends React.Component<Props> {
  static defaultProps: $Shape<Props>;

  handleChange = (value: string) => {
    this.props.setDuration(+value);
  };

  renderDuration() {
    const options = getDurationOptions(this.props.durationOptionsFormat, this.props.durations);

    return (
      <div style={{ width: '8.125rem' }}>
        <FormSelect
          value={this.props.duration.toString()}
          hasNoField
          options={options}
          onChange={this.handleChange}
          dataSelector="BookingFormDurationInput"
        />
      </div>
    );
  }

  render() {
    return (
      <BlockField icon={ICONS.DURATION} title={this.props.title}>
        {this.renderDuration()}
      </BlockField>
    );
  }
}

Duration.defaultProps = defaultProps;

export default Duration;
